import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ArchiveVolume } from '../models/archive/archive-volume.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';
import { BatchArchiveVolume } from '../models/archive/batch-archive-volume.model';
import { environment } from 'src/environments/environment';
import { ArchiveVolumeMoveRequest } from '../models/archive/archive-volume-move-request.model';

@Injectable({
  providedIn: 'root',
})
export class ArchiveVolumeService extends RequestService<ArchiveVolume> {
  static PATH = '/archive/volume';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService,
  ) {
    super(httpClient, ArchiveVolumeService.PATH, globalService.debugUrl);
  }

  batchCreate(data: BatchArchiveVolume) {
    return this.httpClient.post<boolean>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${ArchiveVolumeService.PATH}/batchCreate`,
      data,
    );
  }

  move(request: ArchiveVolumeMoveRequest) {
    return this.httpClient.post<boolean>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${ArchiveVolumeService.PATH}/move`,
      request,
    );
  }

  lock(id: number) {
    return this.httpClient.get<string>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${ArchiveVolumeService.PATH}/lock/${id}`,
    );
  }

  unlock(id: number) {
    return this.httpClient.get<boolean>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${ArchiveVolumeService.PATH}/unlock/${id}`,
    );
  }

  downloadFileByIds(fileName: string, ids: number[]) {
    return this.httpClient.post(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${ArchiveVolumeService.PATH}/downloadFileByIds`,
      { fileName, ids },
      { responseType: 'blob' },
    );
  }
}
